/**
 * Background Sizes
 */

export function getBackgroundSizeClassName(size?: BackgroundSize) {
  return size ? `bgsize--${size}` : '';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/styles/background-size.ts